const CJD_VIDEO_SELECTOR = '.product-gallery__media[data-media-type="video-loop"]';
const CJD_ZOOMABLE_SELECTOR =
  '.product-gallery__media[data-media-type="image"]:not([hidden]), .product-gallery__media[data-media-type="video-loop"]:not([hidden])';

class ProductGalleryVideoController {
  constructor() {
    this.patchLightbox();
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindGalleries());
    } else {
      this.bindGalleries();
    }
  }

  bindGalleries() {
    document.querySelectorAll('product-gallery[form]').forEach(gallery => {
      if (gallery.cjdVideoBound) {
        return;
      }
      gallery.cjdVideoBound = true;
      this.bindVariantSelection(gallery);
      this.bindVideoClick(gallery);
    });
  }

  bindVariantSelection(gallery) {
    const form = document.forms[gallery.getAttribute('form')];
    if (!form) {
      return;
    }
    form.addEventListener('variant:change', event => {
      const variant = event.detail && event.detail.variant;
      queueMicrotask(() => this.selectVariantMedia(gallery, variant));
    });
  }

  selectVariantMedia(gallery, variant) {
    const featuredMedia = variant && variant.featured_media;
    if (!featuredMedia) {
      return;
    }
    if (!gallery.querySelector(CJD_VIDEO_SELECTOR)) {
      return;
    }

    const mediaId = String(featuredMedia.id);
    gallery.querySelectorAll('media-carousel').forEach(carousel => {
      const targetIndex = carousel.items.findIndex(item => item.getAttribute('data-media-id') === mediaId);
      const target = carousel.items[targetIndex];
      if (targetIndex === -1 || !target || target.offsetParent === null) {
        return;
      }
      carousel.select(targetIndex, { animate: false });
    });
  }

  bindVideoClick(gallery) {
    gallery.querySelectorAll(CJD_VIDEO_SELECTOR).forEach(slide => {
      slide.addEventListener('click', event => {
        if (event.target.closest('button, a[href]')) {
          return;
        }
        if (!gallery.hasAttribute('allow-zoom') || !window.matchMedia('(min-width: 1000px)').matches) {
          return;
        }
        if (typeof gallery.openZoom === 'function') {
          gallery.openZoom(-1);
        }
      });
    });
  }

  patchLightbox() {
    customElements.whenDefined('product-gallery').then(ProductGallery => {
      if (ProductGallery.prototype.cjdVideoZoomPatched) {
        return;
      }
      ProductGallery.prototype.cjdVideoZoomPatched = true;

      const originalOpenZoom = ProductGallery.prototype.openZoom;
      const controller = this;

      ProductGallery.prototype.openZoom = function (index = 0) {
        const slides = Array.from(this.querySelectorAll(CJD_ZOOMABLE_SELECTOR));
        const hasVideo = slides.some(slide => slide.getAttribute('data-media-type') === 'video-loop');
        if (!hasVideo) {
          return originalOpenZoom.call(this, index);
        }

        const dataSource = slides.map(slide => controller.buildSlideData(slide));

        let mappedIndex;
        if (index < 0) {
          mappedIndex = slides.findIndex(slide => slide.getAttribute('data-media-type') === 'video-loop');
        } else {
          const images = slides.filter(slide => slide.getAttribute('data-media-type') === 'image');
          mappedIndex = slides.indexOf(images[index]);
        }
        if (mappedIndex < 0) {
          mappedIndex = 0;
        }

        controller.registerVideoContent(this.photoswipe);
        this.photoswipe.loadAndOpen(mappedIndex, dataSource);
      };
    });
  }

  buildSlideData(slide) {
    if (slide.getAttribute('data-media-type') === 'video-loop') {
      const video = slide.querySelector('video');
      return {
        type: 'cjd-video',
        sources: Array.from(video.querySelectorAll('source')).map(source => ({ src: source.src, type: source.type })),
        poster: video.getAttribute('poster'),
        width: parseInt(video.getAttribute('width')) || 1000,
        height: parseInt(video.getAttribute('height')) || 1500,
        thumbnailElement: video
      };
    }

    const image = slide.querySelector('img');
    return {
      thumbnailElement: image,
      src: image.src,
      srcset: image.srcset,
      msrc: image.currentSrc || image.src,
      width: parseInt(image.getAttribute('width')),
      height: parseInt(image.getAttribute('height')),
      alt: image.alt,
      thumbCropped: true
    };
  }

  registerVideoContent(photoswipe) {
    if (!photoswipe || photoswipe.cjdVideoContentRegistered) {
      return;
    }
    photoswipe.cjdVideoContentRegistered = true;

    photoswipe.on('contentLoad', event => {
      const { content } = event;
      const data = content && content.data;
      if (!data || data.type !== 'cjd-video') {
        return;
      }
      event.preventDefault();

      const container = document.createElement('div');
      container.className = 'pswp__cjd-video';

      const video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      if (data.poster) {
        video.poster = data.poster;
      }
      (data.sources || []).forEach(item => {
        const source = document.createElement('source');
        source.src = item.src;
        source.type = item.type;
        video.appendChild(source);
      });

      container.appendChild(video);
      content.element = container;
    });

    photoswipe.on('contentDeactivate', event => {
      const video = event.content && event.content.element && event.content.element.querySelector('video');
      video?.pause();
    });
    photoswipe.on('contentActivate', event => {
      const video = event.content && event.content.element && event.content.element.querySelector('video');
      video?.play().catch(() => {});
    });
  }
}

new ProductGalleryVideoController();
